export default function filtreConcurrent(rayon, coordonnees, concurrents) {
  const coordonnesGPS = {
    latitudeMin: coordonnees.lat - rayon / 1.852 / 60,
    latitudeMax: coordonnees.lat + rayon / 1.852 / 60,
    longitudeMin: coordonnees.lng - rayon / 1.852 / 60,
    longitudeMax: coordonnees.lng + rayon / 1.852 / 60,
  };
  
  return concurrents.filter(el => el.position !== null
                     && el.position.lat !== null && el.position.lng !==  null
                     && el.position.lat > coordonnesGPS.latitudeMin && el.position.lat < coordonnesGPS.latitudeMax
                     && el.position.lng > coordonnesGPS.longitudeMin && el.position.lng < coordonnesGPS.longitudeMax);
}